import { CombineComponents } from "./CombineComponents";
import { CompanyProvider } from "./Companies/Context";
import { DivisionProvider } from "./Divisions/Context";
import { DrawerProvider } from "./Drawer/Context";
import { UserProvider } from "./Users/Context";

const providers = [CompanyProvider, DivisionProvider, DrawerProvider, UserProvider];

export const AppContextProvider = CombineComponents(...providers);
